import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import React from 'react'

const TruncateBase = styled.div`
  ${({ width }) => width && css`width: ${width}px;`}
  ${({ maxWidth }) => maxWidth && css`max-width: ${maxWidth}px;`}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Truncate = ({ children, ...props }) => {
  return (
    <TruncateBase {...props}>
      {children}
    </TruncateBase>
  )
}
Truncate.propTypes = {
  children: PropTypes.any,
  tagType: PropTypes.any,
  color: PropTypes.string
}

export default Truncate
